import React from "react";

export default function Backicon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M256 480C379.712 480 480 379.712 480 256C480 132.288 379.712 32 256 32C132.288 32 32 132.288 32 256C32 379.712 132.288 480 256 480ZM256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
        fill="#F1F1F2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M300.451 131.553C307.325 138.427 307.325 149.57 300.451 156.444L201.891 255.004L299.46 338.636C306.84 344.961 307.695 356.072 301.369 363.452C295.043 370.833 283.932 371.687 276.552 365.361L164.552 269.361C160.83 266.171 158.607 261.573 158.419 256.674C158.231 251.775 160.095 247.02 163.561 243.553L275.561 131.553C282.434 124.68 293.578 124.68 300.451 131.553Z"
        fill="#F1F1F2"
      />
    </svg>
  );
}
